/* eslint-disable react-hooks/exhaustive-deps  */
/* eslint-disable array-callback-return  */
import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Order as OrderContainer } from 'app/modules/order';
import { Button } from 'app/components';
import useConfig from 'app/hooks/useConfig';
import SuccessContainer from '../Success';
import { clearErrorApi } from 'app/store/layout/actions';

const propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      userSessionId: PropTypes.string
    }).isRequired
  }).isRequired,
  fetchPurchase: PropTypes.func.isRequired,
  location: PropTypes.shape({
    state: PropTypes.object.isRequired,
  }).isRequired,
  clearOrder: PropTypes.func.isRequired,
};

const ReservationSuccess = ({
  history: { push },
  match: {
    params: { userSessionId }
  },
  fetchPurchase,
  location: { state },
  clearOrder,
}) => {
  const [t] = useTranslation();
  const {
    routes,
  } = useConfig();
  // const prevRoute = state;
  const fetch = useCallback(fetchPurchase.bind(null, userSessionId), [
    userSessionId,
    fetchPurchase
  ]);


  useEffect(() => {
    clearErrorApi();
    clearOrder();

    return () => {
      clearOrder();
    };
  }, []);

  useEffect(() => {
    fetch()
  }, [])

  useEffect(() => {
    const handleBrowserBackClick = event => {
      push(routes.movies.pattern)
    };
    window.addEventListener('popstate', handleBrowserBackClick);
    window.history.pushState(null, null, window.location.href);
    return () => {
      setTimeout(()=>{
        window.removeEventListener('popstate', handleBrowserBackClick);
      },5000)
    };
  }, []);

  return (
    <SuccessContainer
      render={({ fetchPDF }) => (
        < OrderContainer
          title={t('purchase.reservation_success.title')}
          label={t('purchase.reservation_success.label')}
          info={t('purchase.reservation_success.info')}
          fetch={fetch}
        >
          <Button isDefault to={routes.fallback.pattern} className="b-order__actions-btn">
            {t('common.to_home_page')}
          </Button>
          <Button isPrimary onClick={fetchPDF} className="b-order__actions-btn">
            {t('common.download_tickets')}
          </Button>
        </OrderContainer>
      )
      }
    />
  );
};

ReservationSuccess.propTypes = propTypes;
export default ReservationSuccess;
